export default __webpack_public_path__ + "static/media/Banner_Top_01.c401523e.jpg";